// extracted by mini-css-extract-plugin
export default {"noteSlip":"SingleNote_noteSlip__epa8d","dateTime":"SingleNote_dateTime__ST2UV"};